module.exports = __webpack_public_path__ + "img/logo_letters.3611de26.png";